import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../TimeModal/TimeModalContext';

import { formatNull, formatDate } from '../../Utils/GlobalUtils';

import Loading from '../Loading';

import styles from '../../styles/DynamicModal.module.css';

const PhasesCase = ({ caseId, phaseId, dateEndCase, caseStatus, sideReload }) => {

    const { openTimeModal } = useTimeModal();
    const [phases, setPhases] = React.useState([]);
    const [warning, setWarning] = React.useState('');
    const [reload, setReload] = React.useState(true);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        axios.get(`/api/get-info-case-phases?caseId=${caseId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
        })
        .then(response => {
            if (response.data.length === 0) {
                setWarning('Не удалось загрузить компонент.');
            } else {
                setWarning('');
                setPhases(response.data);
            }
        })
        .catch(error => {
            if (error.response?.data.action == 'logout') {
                window.location.href = '/auth/logout';
            }
            setWarning(`Ошибка при загрузке этапов:  ${error.response?.data.message || error.message}`);
        })
        .finally(() => {
            setLoading(false);
            setReload(false);
        })
    }, [reload, caseId, sideReload]);

    const goPhase = (caseId, newPhaseId) => {
        setLoading(true);
        axios.put(`/api/go-phase?caseId=${caseId}&phaseId=${newPhaseId}`)
        .then(() => {
            openTimeModal('Дело продвинуто', 'success');
            setReload(true);
        })
        .catch((error) => {
            openTimeModal(`Не удалось продвинуть дело.  ${error.response?.data.message || error.message}`, 'error');
        })
        .finally(() => {
            setLoading(false);
        })
    };

    const setCaseClose = (caseId) => {
        axios.put(`/api/set-case-close?caseId=${caseId}`)
        .then(() => {
            openTimeModal('Дело закрыто', 'success');
            setReload(true);
        })
        .catch((error) => {
            openTimeModal(`Не удалось закрыть дело.  ${error.response?.data.message || error.message}`, 'error');
        })
    };


    return (
        phaseId==null ? (
            <a>{formatNull(phaseId)}</a>
        ) : (
        <div className={styles.phaseContainer}>
            {caseStatus=="В работе" ? (
                loading ? 
                <Loading /> 
                :
                <>
                    <div className={styles.currentPhase}>
                        <svg style={{width: '37px'}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="angle-double-right"><path fill="#6563FF" d="M8.46,8.29A1,1,0,1,0,7,9.71L9.34,12,7,14.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l3-3a1,1,0,0,0,0-1.42Zm8.5,3-3-3a1,1,0,0,0-1.42,1.42L14.84,12l-2.3,2.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l3-3A1,1,0,0,0,17,11.29Z"></path></svg>
                        {phases.phaseName}
                        <a style={{fontSize: '14px'}}>Этап должен быть исполнен до: {dateEndCase}</a>
                    </div>
                    {phases.nextPhases && phases.nextPhases.length > 0 ? 
                    <>
                        <a className={styles.bridge}><svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 24 24" id="arrow-down"><path fill="currentColor" d="M17.71,11.29a1,1,0,0,0-1.42,0L13,14.59V7a1,1,0,0,0-2,0v7.59l-3.29-3.3a1,1,0,0,0-1.42,1.42l5,5a1,1,0,0,0,.33.21.94.94,0,0,0,.76,0,1,1,0,0,0,.33-.21l5-5A1,1,0,0,0,17.71,11.29Z"></path></svg></a>
                        {phases.nextPhases.map((nextPhase, index) => (
                            <React.Fragment key={index}>
                                <div className={styles.nextPhases}>
                                    <span>
                                        <svg id="clock" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M15.09814,12.63379,13,11.42285V7a1,1,0,0,0-2,0v5a.99985.99985,0,0,0,.5.86621l2.59814,1.5a1.00016,1.00016,0,1,0,1-1.73242ZM12,2A10,10,0,1,0,22,12,10.01114,10.01114,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,12,20Z"></path></svg>
                                        {nextPhase.name}
                                    </span>
                                    <a type='button' className={styles.buttonGoPhase} onClick={() => goPhase(caseId, nextPhase.id)}>Выбрать этот этап как следующий для продвижения дела в системе</a>
                                </div>
                                {index < phases.nextPhases.length - 1 && (
                                    <a className={styles.bridge}>или</a>
                                )}
                            </React.Fragment>
                        ))}
                    </>
                    : 
                    <>
                        <a className={styles.bridge}><svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 24 24" id="arrow-down"><path fill="currentColor" d="M17.71,11.29a1,1,0,0,0-1.42,0L13,14.59V7a1,1,0,0,0-2,0v7.59l-3.29-3.3a1,1,0,0,0-1.42,1.42l5,5a1,1,0,0,0,.33.21.94.94,0,0,0,.76,0,1,1,0,0,0,.33-.21l5-5A1,1,0,0,0,17.71,11.29Z"></path></svg></a>
                        <div className={styles.nextPhases}>
                            <span>
                                <svg style={{width: '30px'}} viewBox="0 0 24 24" id="check"><path fill="currentColor" d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z"></path></svg>
                                Дело завершено
                            </span>
                            <a type='button' className={styles.buttonGoPhase} onClick={() => setCaseClose(caseId)}>Закрыть дело в системе</a>
                        </div>
                    </>
                    }
                </>
            ) : (
                <a className={styles.phaseOComplite}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="check-circle"><path fill="currentColor" d="M14.72,8.79l-4.29,4.3L8.78,11.44a1,1,0,1,0-1.41,1.41l2.35,2.36a1,1,0,0,0,.71.29,1,1,0,0,0,.7-.29l5-5a1,1,0,0,0,0-1.42A1,1,0,0,0,14.72,8.79ZM12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"></path></svg>
                    Дело завершено
                </a>
            )}
        </div>)
    )
}

export default PhasesCase;